import axios from 'axios'
import clientConfigApi from '../config/config'
import { onControlClick } from '../JS/setColors'
import { CMSPath } from '../config/constant'

 function getRoomControlPath() {
  const roomControlType = localStorage.getItem("roomControlInterface") || process.env.REACT_APP_ROOMCONTROLTYPE;
  return roomControlType === 'InnCom' ? '/Connector/rest/roomControl' : '/RoomControl/rest/roomControl';
}

//this is action wihich is use to switch between the controller like AC, speaker, light etc.
export const currentControlActive = (currentControl) => {
  return {
    type: 'Current_Control_Data',
    payload: currentControl
  }
}

//--------------------------Bose API-------------------------------------

// This is a API call to get the speaker current status which include current volume, music source.
export const getSpeakerStatus = (callFrom, guestDetail, speakerConnectCallBack) => {
  return async dispatch => {
    axios.post(
      //`${CMSPath}/RoomControl/rest/soundControlDetails/get`,
      //`http://192.168.86.24:8080/RoomControl/rest/soundControlDetails/get`,
      'http://demo0570873.mockable.io/soundControlDetails/get',
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
        },
        'payload': {
          "locationId": guestDetail.locationId
        }
      }
    ).then((res) => {
      if (res && res.data && res.data.payload) {
        console.log("soundControlDetails response on success", res.data);
        dispatch({
          type: 'Set_Speaker_Source_Info',
          payload: {
            soundBarData: res.data.payload
          }
        })
      }
      if (callFrom === "speakerControl" && speakerConnectCallBack) {
        speakerConnectCallBack(true);
      }
    })
      .catch(
        (response) => {
          console.log("speaker status Api failed with the status code:", response);
          if (callFrom === "speakerControl" && speakerConnectCallBack) {
            speakerConnectCallBack(false);
          } else {
            console.log('@@@');
          }
        }
      )
  }
}

/*
  "speakerInfoAPI" this API is not of any use of this App.
  This is needed to hit go let CMS get the Device ID of bose speaker.
  so that it can be use while setting zone.
*/

export const speakerInfoAPI = (guestDetail, action) => {
  axios.post(
    `${CMSPath}/RoomControl/rest/roomControl`,
    {
      "header": {
        "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
        "locationId": guestDetail.locationId,
        "action": action
      },
      "payload": {
      }
    }
  ).then((res) => {
    console.log("speaker info API success.", res);
  })
    .catch(
      (response) => {
        console.log("speaker info Api failed:", response);
      }
    )
}

export const setZoneAPI = (guestDetail, speaker, action) => {
  return async dispatch => {
    axios.post(
      `${CMSPath}/RoomControl/rest/roomControl`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,
          "action": action
        },
        "payload": {
          "speakerName": speaker.id
        }
      }
    ).then((res) => {
      console.log("speaker set zone API success.", res);
      if (res && res.data && res.data.header.status.code === "SUCCESS") {
        dispatch({
          type: 'Set_Speaker_Zone',
          payload: true
        })
      }
    })
      .catch(
        (response) => {
          console.log("speaker set zone Api failed:", response);
        }
      )
  }
}

//This is a API call for volume control 
export const setVolume = (volume, action, speaker, guestDetail, callBackFunction) => {
  return async dispatch => {
    axios.post(
      `${CMSPath}/RoomControl/rest/roomControl`,
      //`http://192.168.86.24:8080/RoomControl/rest/roomControl`,
      //this path is wrong. update RoomControl to Connector in path like VDA API.
      //for demo porpose can't do it right now.
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,
          "action": action
        },
        "payload": {
          "magnitude": volume,
          "speakerName": speaker.id
        }
      }
    ).then((res) => {
      console.log("volume control response on success", res);
      dispatch({
        type: 'Set_Speaker_Volume',
        payload: volume
      })

    })
      .catch(
        (response) => {
          callBackFunction();
          console.log("Api failed with the status code:", response);
        }
      )
  }
}

export const sourceChange = (action, controller, guestDetail, speaker, callBackFunction) => {
  console.log("speaker", speaker.id);
  return async dispatch => {
    axios.post(
      `${CMSPath}/RoomControl/rest/roomControl`,
      //`http://192.168.86.24:8080/RoomControl/rest/roomControl`,
      //`${CMSPath}/RoomControl/rest/roomControl`,
      //this path is wrong. update RoomControl to Connector in path like VDA API.
      //for demo porpose can't do it right now.
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,
          "action": action
        },
        "payload": {
          "magnitude": controller,
          "speakerName": speaker.id
        }
      }
    ).then((res) => {
      console.log("source change API success", res);
      if (res && res.data && res.data.header.status.code === "SUCCESS") {
        dispatch({
          type: 'Set_Song_source',
          payload: controller
        })
        callBackFunction(true, controller);
      } else if (res.data.header.status.code === "FAILED") {
        callBackFunction(false, controller);
      }
    })
      .catch(
        (response) => {
          callBackFunction(false, controller);
          console.log("Api failed with the status code:", response);
        }
      )
  }
}

export const changeSpeaker = (speaker) => {
  return {
    type: 'Change_Speaker',
    payload: speaker
  }
}

export const getSpeakerList = (speakerList) => {
  return {
    type: 'Set_Speaker_List',
    payload: speakerList
  }
}

export const setSourceForAll = (source) => {
  return {
    type: 'Set_Source_For_All_Speaker',
    payload: source
  }
}
//--------------------------------VDA API-----------------------------------

export const setPowerSwitch = (status) => {
  return {
    type: 'Set_Power_Switch',
    payload: status
  }
}

export const sendCommand = (action, guestDetail, section, sendCommandCallBack, id, zone) => {

  return async dispatch => {
    axios.post(
      `${CMSPath}/RoomControl/rest/roomControl`,
      //`http://192.168.86.24:8080/RoomControl/rest/roomControl`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,//"14",
          "action": action,
          "zone": zone
        },
        "payload": {}
      }
    ).then((res) => {
      console.log(`sendCommand success for Action ${action}`, res);
      sendCommandCallBack(section, true);
      if (section === "fanSpeed") {
        dispatch({
          type: 'Set_Fan_Speed',
          payload: id
        })
      }
    })
      .catch(
        (response) => {
          sendCommandCallBack(section, false);
          console.log("Api failed with the status code:", response);
        }
      )
  }
}

export const sendACCommand = (action, Temprature, change, guestDetail, zone, callBack) => {
  let temp
  return async dispatch => {
    axios.post(
      `${CMSPath}/RoomControl/rest/roomControl`,
      //`http://192.168.86.24:8080/RoomControl/rest/roomControl`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,
          "action": action,
          "zone": zone
        },
        "payload": {
          "magnitude": `${Temprature}.0`,
          "definedCircuit": "-F"
        }
      }
    ).then((res) => {
      // console.log(`sendACCommand success for Action ${action}`, res);
    })
      .catch(
        (response) => {
          // console.log("Api failed with the status code:", response);
          if (callBack) {
            if (change === "inc") {
              callBack("inc")
            } else { 
              callBack("dec")
            }
          } else {
            if (change === "inc") {
              temp = Temprature - 1
            } else {
              temp = Temprature + 1
            }
            dispatch({
              type: 'Increase_Ac_Temp',
              payload: temp
            })
          }
        }
      )
  }
}

export const TempChange = (change, AcTemp) => {
  return {
    type: 'Increase_Ac_Temp',
    payload: AcTemp
  }
}

export const setLightScene = (id, action, currentScene, guestDetail, menuColor, zone) => {
  return async dispatch => {
    axios.post(
      //`http://192.168.86.24:8080/RoomControl/rest/roomControl`,
      `${CMSPath}/RoomControl/rest/roomControl`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,//"14",
          "action": action,
          "zone": zone
        },
        "payload": {
          "magnitude": id
        }
      }
    ).then((res) => {
      console.log(`setLightScene success ${action}`, res);
      //sendCommandCallBack(true);
    })
      .catch(
        (response) => {
          //sendCommandCallBack(false);
          if (action !== "unlockDoor") {
            setTimeout(() => {
              dispatch({
                type: 'Set_Current_Light_Scene',
                payload: currentScene
              })
              onControlClick(currentScene, "lightMood", menuColor);
            }, 200);
          }
          console.log("setLightScene Api failed with the status code:", response);
        }
      )
  }
}

export const changeCurtain = (curtain, action, guestDetail, status, zone) => {
  return async dispatch => {
    axios.post(
      //`http://192.168.86.24:8080/RoomControl/rest/roomControl`,
      `${CMSPath}/RoomControl/rest/roomControl`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,
          "action": action,
          "zone": zone
        },
        "payload": {
          "magnitude": curtain
        }
      }
    ).then((res) => {
      console.log(`${action} success`, res);
      if (res && res.data && res.data.header.status.code === "SUCCESS") {
        dispatch({
          type: 'Set_Current_Curtain_Mode',
          payload: action === "setCurtainCtrlScene" ? `${curtain}${zone}ON` : `${curtain}${zone}OFF`
        })
      }
    })
      .catch(
        (response) => {
          console.log("SetCurtain Api failed with the status code:", response);
        }
      )
  }
}

export const setCurrentCurtain = (curtain) => {
  return {
    type: 'Set_Current_Curtain_Mode',
    payload: curtain
  }
}

export const setCurrentLightScene = (lightScene) => {
  return {
    type: 'Set_Current_Light_Scene',
    payload: lightScene
  }
}

//we call this API on each button click to get the updated status of  
export const VDAStatusApi = (sessionToken, guestDetail, VDAStatusCallBack, thisRef) => {
  //console.log("@@", sessionToken, guestDetail, VDAStatusCallBack, zoneName);
  return dispatch => {
    try {
      axios.post(
        //`${CMSPath}/RoomControl/rest/roomControl/getRoomConfig/ver2`,
        // `${CMSPath}/Connector/rest/roomControl/getRoomControlData`,
        //"https://demo4177233.mockable.io/getRoomConfigData",
        //`http://192.168.87.74:8080/RoomControl/rest/roomControl/getRoomConfigData`,
        "http://demo0570873.mockable.io/getRoomConfigData",
        //"http://192.168.86.24:8080/RoomControl/rest/roomControl/getRoomConfig/ver2",
        {
          "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "sessionToken": sessionToken,
          },
          "payload": {
            "locationId": guestDetail.locationId,
          }
        }
      ).then((res) => {
        let selectedZone = {}
        console.log(`VDA status API success`, res, res.data.payload.data.length);
        if (res && res.data && res.data.header.status.code === "SUCCESS") {
          if (res.data.payload.data.length === 1) {
            selectedZone = res.data.payload.data[0]
          } else {
            selectedZone = {}
          }
          dispatch({
            type: 'Set_Room_Control_Status',
            payload: {
              VDAResponse: res.data.payload,
              VDAZoneList: res.data.payload.data,
              selectedZone: selectedZone
            }
          })
          if (res.data.payload.data.length === 1) {
            let temp = parseInt(res.data.payload.data[0].hvac.temperatureValue.slice(2, 4));
            let roomTemp = parseInt(res.data.payload.data[0].hvac.currentRoomTemperature.slice(2, 4));
            dispatch(
              {
                type: 'Set_Selected_Zone',
                payload:
                {
                  zone: res.data.payload.data[0],
                  seletedIndex: 0,
                  RoomControlStatus: res.data.payload.data[0],
                  currentRoomTemp: roomTemp ? roomTemp : 999,
                  currentFanSpeed: res.data.payload.data[0].hvac.fanSpeed,
                  powerSwitch: res.data.payload.data[0].hvac.mainSwitch,
                  celciusMin: res.data.payload.data[0].hvac.celciusMin,
                  celciusMax: res.data.payload.data[0].hvac.celciusMax,
                  ecoMode: res.data.payload.data[0].hvac.ecoMode
                }
              }
            )
            dispatch(
              {
                type: 'Increase_Ac_Temp',
                payload: temp
              })
          }
        }
        VDAStatusCallBack(true, thisRef);
      })
        .catch(
          (response) => {
            console.log("VDA status Api failed with the status code:", response);
            VDAStatusCallBack(false, thisRef);
          }
        )
    } catch (e) {
      console.log(e);
    }
  }
}

export const setEcoMode = (mode) => {
  return {
    type: 'Set_Eco_Mode',
    payload: mode
  }
}

export const setMakeUPRoom = (status) => {
  return {
    type: 'Set_MakeUPRoom_Mode',
    payload: status
  }
}

export const setDND = (status) => {
  return {
    type: 'Set_DND_Mode',
    payload: status
  }
}
export const setAcSelected = (bool) => {
  return {
    type: 'Set_Ac_Selected',
    payload: bool
  }
}

//------------------------new room control------------------

export const setSelectedZone = (zone, roomTemp, seletedIndex) => {
  if (zone) {
    return {
      type: 'Set_Selected_Zone',
      payload:
      {
        zone: zone,
        seletedIndex: seletedIndex,
        RoomControlStatus: zone,
        currentRoomTemp: roomTemp ? roomTemp : 999,
        currentFanSpeed: zone.hvac.fanSpeed,
        powerSwitch: zone.hvac.mainSwitch,
        celciusMin: zone.hvac.celciusMin,
        celciusMax: zone.hvac.celciusMax,
        ecoMode: zone.hvac.ecoMode
      }
    }
  }
}

export const restoreValue = (updatedVDAZoneList) => {
  return {
    type: 'Restore_Zone_Data',
    payload:
    {
      zone: {},
      seletedIndex: null,
      VDAZoneList: updatedVDAZoneList
    }
  }
}

export const setzoneCount = (count) => {
  return {
    type: 'Set_Zone_Count',
    payload: count
  }
}

export const setSelectedControlZone = (zone) => {
  return {
    type: 'Set_Selected_Control_Zone',
    payload: zone
  }
}

// ------------------------ InnCom Room Control------------------- /Connector/rest/roomControl/getRoomControlData

// const roomControlPath =  process.env.REACT_APP_ROOMCONTROLTYPE == 'InnCom' ? '/Connector/rest/roomControl' : '/RoomControl/rest/roomControl'
let locationId = localStorage.getItem("roomID")

export const getInncomRoomControlData = (sessionToken, guestDetail, CallbackRoomControlData, thisRef) => {
  const roomControlPath = getRoomControlPath();

  return dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"
    try {
      axios.post(
        `${CMSPath}${roomControlPath}/getRoomControlData` + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,
        {
          "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            // "sessionToken": sessionToken,
          },
          "payload": {
            "locationId": locationId || guestDetail.locationId,
            "versionKey": "version2"
          }
        }
      ).then(response => {
        console.log('Room Control Inncom Response : ',  response, response.data.payload.configs.farenheitMin)
        dispatch(
          {
            type: 'Set_Inncom_RommControl_Data',
            payload:
            {
              RoomControlStatus: response.data.payload,
              configs: response.data.payload.configs,
              DND: response.data.payload.DND,
              MUR: response.data.payload.MUR,
              hvac: response.data.payload.hvac,
              lightScene: response.data.payload.lights,
              curtain: response.data.payload.curtain,
              celciusMax: response.data.payload.configs.celciusMax,
              celciusMin: response.data.payload.configs.celciusMin,
              farenheitMin: response.data.payload.configs.farenheitMin,
              farenheitMax: response.data.payload.configs.farenheitMax
            }
          }
        )
        if(CallbackRoomControlData){
          CallbackRoomControlData(true, "", thisRef);
        }
      }).catch(({response = {}}) => {

        if(response && response.data && response.data.header) CallbackRoomControlData(false, response.data.header.status.msg || response.data.header.status.message, thisRef);
        else CallbackRoomControlData(false, "Failed to get the data", thisRef);
      })
    } catch (error){
      console.log('Error in calling Room Control APIs for Inncom : ', error)
      if(window.FireBasePlugin){
        // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
        window.FirebasePlugin.logError("Error in calling Room Control APIs for Inncom " + error)
      }
      if(CallbackRoomControlData){
        CallbackRoomControlData(false, error.message, thisRef);
      }
    } 
  }
}


export const setLightSceneInncom = (id, action, guestDetail,callBack, versionNo) => {
  const roomControlPath = getRoomControlPath();
  const lightCommand = (localStorage.getItem("roomControlInterface") || process.env.REACT_APP_ROOMCONTROLTYPE) == 'InnCom' ? 'setLightCtrlScene' : 'setLightCtrlScene2'

  return async dispatch => {
    axios.post(
      `${CMSPath}${roomControlPath}`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": locationId || guestDetail.locationId,//"14",
          "action": lightCommand,
          "versionKey": versionNo=="V1" ? undefined : "version2"
        },
        "payload": {
          "magnitude": id,
          "definedCircuit": id
        }
      }
    ).then((res) => {
      console.log(`setLightScene success ${action}`, res);
      callBack(true)
      //sendCommandCallBack(true);
    })
      .catch(
        (response) => {
          //sendCommandCallBack(false);
          // if (action !== "unlockDoor") {
          //   setTimeout(() => {
          //     dispatch({
          //       type: 'Set_Current_Light_Scene',
          //       payload: currentScene
          //     })
          //     onControlClick(currentScene, "lightMood", menuColor);
          //   }, 200);
          // }
          console.log("setLightScene Api failed with the status code:", response);
          callBack(false)
          if(window.FireBasePlugin){
            // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
            window.FirebasePlugin.logError("setLightScene Api failed with the status code: " + response)
          }
        }
      )
  }
}

export const changeCurtainInncom = (curtain, action, guestDetail, status, zone) => {
  const roomControlPath = getRoomControlPath();

  return async dispatch => {
    axios.post(
      `${CMSPath}${roomControlPath}`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": locationId || guestDetail.locationId,
          "action": action,
          "versionKey":"version2"
        },
        "payload": {
          "magnitude": curtain,
          "definedCircuit": curtain
        }
      }
    ).then((res) => {
      console.log(`${action} success`, res);
      if (res && res.data && res.data.header.status.code === "SUCCESS") {
        // dispatch({
        //   type: 'Set_Current_Curtain_Mode',
        //   payload: action === "setCurtainCtrlScene" ? `${curtain}${zone}ON` : `${curtain}${zone}OFF`
        // })
      }
    })
      .catch(
        (response) => {
          console.log("SetCurtain Action Api failed with the status code:", response);
          if(window.FireBasePlugin){
            // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
            window.FirebasePlugin.logError("setCurtain Action Api failed with the status code: " + response)
          }
        }
      )
  }
}

export const changeRoomTemperature = (AC, action, guestDetail, temperature, unit) => {
  const roomControlPath = getRoomControlPath();


  return async dispatch => {
    axios.post(
      `${CMSPath}${roomControlPath}`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": locationId || guestDetail.locationId,
          "action": action,
          "identifier": AC,
          "versionKey":"version2"
        },
        "payload": {
          "magnitude": temperature,
          "definedCircuit": unit
        }
      }
    ).then((res) => {
      console.log(`${action} success`, res);
      if (res && res.data && res.data.header.status.code === "SUCCESS") {
        // dispatch({
        //   type: 'Set_Current_Curtain_Mode',
        //   payload: action === "setCurtainCtrlScene" ? `${curtain}${zone}ON` : `${curtain}${zone}OFF`
        // })
      }
    })
      .catch(
        (response) => {
          console.log("HVAC Action Api failed with the status code:", response);
          if(window.FireBasePlugin){
            // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
            window.FirebasePlugin.logError("HVAC Action Api failed with the status code: " + response)
          }
        }
      )
  }
}

export const setSelectedAC = (hvac, roomTemp, selectedIndex) => {
  if (hvac) {
    return {
      type: 'Set_Selected_AC',
      payload:
      {
        hvac: hvac,
        selectedIndex: selectedIndex,
        currentRoomTemp: roomTemp ? roomTemp : 999,
        // currentAcTemp: hvac.temperatureValue.slice(2, 4),
        currentFanSpeed: hvac.fanSpeed,
        // powerSwitch: hvac.mainSwitch,
        // celciusMin: configs.celciusMin,
        // celciusMax: configs.celciusMax,
        acMode: hvac.acMode
      }
    }
  }
}

export const setVDASelectedAC = (hvac, roomTemp, selectedIndex) => {
  if (hvac) {
    return {
      type: 'Set_VDA_Selected_AC',
      payload:
      {
        hvac: hvac,
        selectedIndex: selectedIndex,
        currentRoomTemp: roomTemp ? roomTemp : 999,
        currentFanSpeed: hvac.fanSpeed,
        acMode: hvac.acMode
      }
    }
  }
}
export const TempChangeVDA = (change, AcTemp) => {
  return {
    type: 'Increase_Ac_Temp_VDA',
    payload: AcTemp
  }
}

export const TempChangeInncom = (change, AcTemp) => {
  return {
    type: 'Increase_Ac_Temp_Inncom',
    payload: AcTemp
  }
}

export const sendAcCommand = (action, magnitude, definedCircuit, identifier, guestDetail, section, callBack, versionNo) => {
  console.log('sendACcommand called')
  let temp
  const roomControlPath = getRoomControlPath();

  return async dispatch => {
  console.log('sendACcommand inside return')
  axios.post(
    `${CMSPath}${roomControlPath}`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": locationId || guestDetail.locationId,
          "action": action,
          "identifier": versionNo=="V1" ? undefined : identifier,
          "versionKey": versionNo=="V1" ? undefined : "version2"
        },
        "payload": {
          "magnitude": magnitude,
          "definedCircuit": definedCircuit
        }
      }
    ).then((res) => {
      console.log(`sendACCommand success for Action ${action}`, res);
      callBack(section, true)
    })
      .catch(
        (response) => {
          console.log("Inncom Room Control Api failed with the status code:", response);
          callBack(section, false)

          if(window.FireBasePlugin){
            // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
            window.FirebasePlugin.logError("HVAC Action Api failed with the status code: " + response)
          }
        }
      )
  }
}


// export const getTintControlData = (guestDetail, callback) => {

//   return async dispatch => {
//   axios.post(
//       `${CMSPath}/RoomControl/rest/roomControl/getTintControlData`,
//       {
//         "payload": {
//           "locationId": guestDetail.locationId
//         }
//       }
//     ).then((res) => {
//       console.log('Tint Control Data Response', res)
//       dispatch(
//         {
//           type: 'Set_Tint_Control_Data',
//           payload: res.data.payload
//         })
//         callback()
//     })
//       .catch((response) => {
//         callback()
//         if(window.FireBasePlugin){
//             window.FirebasePlugin.logError("Tint API failed to get the data " + response)
//           }
//         }
//       )
//   }
// }

export const seTintControlData = (obj) => {
  return {
    type: "Set_Tint_Control_Data",
    payload: obj
  }
}

export const getTintControlData = (guestDetail, callback) => {

  return async dispatch => {
  axios.post(
      `${CMSPath}/RoomControl/rest/roomControl/getTintControlData/v2`,
      {
        "payload": {
          "locationId": locationId || guestDetail.locationId,
        }
      }
    ).then((res) => {
      console.log('Tint Control Data Response', res)
      dispatch(
        {
          type: 'Set_Tint_Control_Data',
          payload: res.data.payload
        })
        callback(true)
    })
      .catch((response) => {
        callback(false)
        if(window.FireBasePlugin){
            window.FirebasePlugin.logError("Tint API failed to get the data " + response)
          }
        }
      )
  }
}

export const setTint = (guestDetail, identifier, tintLevel, compRef, callback) =>{
  return async dispatch => {
    axios.post(
      `${CMSPath}/RoomControl/rest/roomControl`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": locationId || guestDetail.locationId,
          "action": "setTintState",
          "identifier" : identifier
        },
        "payload": {
          "magnitude":tintLevel,
          "definedCircuit":tintLevel
        }
      }
      
    ).then((res) => {
      console.log('Tint Control Data Response', res)
      callback(true, tintLevel, compRef)
    })
      .catch((response) => {
          if(window.FireBasePlugin){
            window.FirebasePlugin.logError("Set Tint API Failed " + response)
          }
          callback(false, tintLevel, compRef)
        }
      )
  }
}

export const getTvLiftStatus = (locationId, callback) => {
   if (process.env.REACT_APP_DISABLE_TV_LIFT_STATUS_API == "true") {
        return () => {};
    }

  let guestDetail = JSON.parse(localStorage.getItem("Guest_Details"))
  const roomControlPath = getRoomControlPath();


  return async dispatch => {
    axios.post(
        `${CMSPath}${roomControlPath}/getTVLiftStatusData`,
        {
          "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "locationId": locationId || guestDetail && guestDetail.guestDetails && guestDetail.guestDetails.locationId,
          }
        }
      ).then((res) => {
        console.log('Tint Control Data Response', res)
          if(res.data.header.status.code == "SUCCESS"){
            dispatch(
              {
                type: 'Set_TV_Lift_Data',
                payload: res.data.payload
              })

              if(res.data && res.data.payload && res.data.payload.length > 0){
                callback(true)
              } else {
                callback(false, "No TVs available to control were found")
              }
          } else {
            callback(false, res.data.header.status.msg)
          }
      })
      .catch(({response ={}}) => {
        callback && callback(false, response.data && response.data.header && response.data.header.status.msg || "")
          if(window.FireBasePlugin){
              window.FirebasePlugin.logError("TV lift status failed to get the data " + response)
            }
          }
        )
    }
}

export const setTvLiftStatus = (locationId, command, identifier, callback) => {

  let guestDetail = JSON.parse(localStorage.getItem("Guest_Details"))
  const roomControlPath = getRoomControlPath();


  return async dispatch => {
    axios.post(
        `${CMSPath}${roomControlPath}`,
        {
          "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
            "locationId": locationId || guestDetail && guestDetail.guestDetails && guestDetail.guestDetails.locationId,
              "action": command,
              "identifier": identifier,
              "versionKey": "version2",
          },
          "payload": {
              "magnitude": "",
              "definedCircuit": ""
          }
        }
      ).then((res) => {
        if(res.data.header.status.code == "SUCCESS"){
          callback(true)
        } else {
          callback(false, res.data.header.status.msg)
        }
      })
      .catch(({response ={}}) => {
        callback && callback(false, response.data.header.status.msg)
          if(window.FireBasePlugin){
              window.FirebasePlugin.logError("TV lift status failed to get the data " + response)
            }
          }
        )
    }
}

export const getLeaSpeakerData = (locationId, callback) => {

  let guestDetail = JSON.parse(localStorage.getItem("Guest_Details"))

  return async dispatch => {
    axios.post(
        `${CMSPath}/RoomControl/rest/soundControlDetails/get`,
        {
          "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
              "versionKey" : "version2"
          },
          "payload": {
              "locationId": locationId || guestDetail && guestDetail.guestDetails && guestDetail.guestDetails.locationId
          }
      }
      
      ).then((res) => {
        if(res.data.header.status.code == "SUCCESS"){
          callback(true, res.data.payload)
          dispatch(
            {
              type: 'Set_LEA_Spaeker_Data',
              payload: res.data.payload
            })
        } else {
          callback(false, res.data.header.status.msg)
        }
      })
        .catch(({response ={}}) => {
          callback && callback(false, response.data.header.status.msg)
          console.log("speaker response", response)
          if(window.FireBasePlugin){
              window.FirebasePlugin.logError("TV lift status failed to get the data " + response)
            }
          }
        )
    }
}

export const sendLeaSpeakerCommand = (action, locationId, zoneMaster, zoneSlaves, callBack, volume, inputSource) => {

  let guestDetail = JSON.parse(localStorage.getItem("Guest_Details"))
  const roomControlPath = getRoomControlPath();


  return async dispatch => {
    axios.post(`${CMSPath}${roomControlPath}`, 
      {
        "header" :{
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "action": action,
          "locationId": locationId || guestDetail && guestDetail.guestDetails && guestDetail.guestDetails.locationId
        },
        "payload": {
          "inputsource": inputSource,
          "zoneMaster": zoneMaster,
          "zoneSlaves": zoneSlaves,
          "volume": volume,
        }
      })
      .then(res => {
        if(res.data.header.status.code == "SUCCESS"){
          callBack && callBack(true, res)
        } else {
          callBack && callBack(false, res.data.header.status.msg)
        }
      })
      .catch(({response = {}}) => {
        callBack && callBack(false, response.data.header.status.code)
      })
  }
}

export const setSelectedMasterDevice = dev => {
  return {
   type: "Set_Selected_Master_Device",
   payload: dev   
  }
}

export const setLeaSpeakerData = data => {
  return {
    type: 'Set_LEA_Spaeker_Data',
    payload: data
  }
}

export const setSpeakerInZone = data => {
  return{
    type: "Set_Speaker_In_Zone",
    payload: data
  }
}
export const setCurrentWindowTintPage = page => {
  return {
    type: "Set_Current_Window_Tint_Page",
    payload: page
  }
}

export const setCurrentZoneStep = step => {
  return {
    type: "Set_Current_Zone_Step",
    payload: step
  }
}

export const setSelectedWindows = arr => {
  return {
    type: "Set_Selected_Windows",
    payload: arr
  }
}

export const setSelectedTintLevel = level => {
  return {
    type: "Set_Selected_Tint_Level",
    payload: level
  }
}

export const setWindowTint = (guestDetail ,action , identifier, tintLevel, startDate, endDate, callback) =>{
  console.log("guestDetail, identifier, tintLevel, startDate, endDate", guestDetail, identifier, tintLevel, startDate, endDate);
  return async dispatch => {
    axios.post(
      `${CMSPath}/RoomControl/rest/roomControl`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,
          "action": action,
          "identifier" : identifier
        },
        "payload": {
          "versionKey": "v2",
          "magnitude":tintLevel,
          "endDate": endDate,
          "startDate": startDate
        }
      }
      
    ).then((res) => {
      console.log('Tint Control Data Response', res)
      callback(true, tintLevel)
    })
      .catch((response) => {
          // if(window.FireBasePlugin){
          //   window.FirebasePlugin.logError("Set Tint API Failed " + response)
          // }
          callback(false, tintLevel)
        }
      )
  }
}


export const clearTintState = (guestDetail, identifier, callback) =>{
  return async dispatch => {
    axios.post(
      `${CMSPath}/RoomControl/rest/roomControl`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,
          "action": "clearTintState",
          "identifier" : identifier
        }
      }
      
    ).then((res) => {
      callback(true)
    })
      .catch((response) => {
        callback(false)
    })
  }
}


export const updateSchedule = (guestDetail, schedule, callback) =>{
  return async dispatch => {
    axios.post(
      `${CMSPath}/RoomControl/rest/roomControl`,
      {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": guestDetail.locationId,
          "action": "updateSchedule",
        },
        "payload": {
          "schedule": schedule
        }
      }
      
    ).then((res) => {
      callback(true)
    })
      .catch((response) => {
        callback(false)
      })
  }
}

export const getRoomControlZonesWiseData = ( guestDetail ) => {
  if (process.env.REACT_APP_DISABLE_ROOM_CONTROLS_ZONEs_WISE_API == "true") {
    return () => {};
  }

  return dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin";
    const roomControlPath = getRoomControlPath();
    
    try {
      axios.post(
        `${CMSPath}${roomControlPath}/zonesWiseData` + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,
        {
          "header": {
            // "sessionToken": sessionToken,
          },
          "payload": {
            "locationId": locationId || guestDetail.locationId,
            // "versionKey": "version2"
          }
        }
      ).then(response => {
        console.log('Room Control Zones Wise Response : ',  response)
        // CallbackFunc(response)
        dispatch(
          {
            type: 'Set_Room_Control_Zones_Wise_Data',
            payload:
            {
              rooms: response.data.payload.data,
              fanSpeedConfig: response.data.payload.configs.fanSpeedConfig
            }
          }
        )
       
      }).catch(({response = {}}) => {

        if(response && response.data && response.data.header){
          console.log(response.data.header.status.msg);}

      })
    } catch (error){
      console.log('Error in calling Room Control APIs for Zones Wise Data : ', error)
      if(window.FireBasePlugin){
        // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
        window.FirebasePlugin.logError("Error in calling Room Control APIs for for Zones Wise Data " + error)
      }
    } 
  }
}


// ------------------------ VDA Room Control-------------------/RoomControl/rest/innspire/roomControl

export const getVDARoomControlData = ( guestDetail, CallbackRoomControlData, thisRef) => {
  const roomControlPath = "/RoomControl/rest/innspire/roomControl"

  return dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"
    try {
      axios.post(
        `${CMSPath}${roomControlPath}/getRoomControlData` + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,
        {
          "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": locationId || guestDetail.locationId,
          },
        }
      ).then(response => {
        console.log('Room Control VDA Response : ',  response, response.data.payload.configs.farenheitMin)
        dispatch(
          {
            type: 'Set_VDA_RommControl_Data',
            payload:
            {
              RoomControlData: response.data.payload,
              configs: response.data.payload.configs,
              DND: response.data.payload.roomControlData[0].DND,
              MUR: response.data.payload.roomControlData[0].MUR,
              hvac: response.data.payload.roomControlData[0].hvac,
              lightScene: response.data.payload.roomControlData[0].lightScene,
              zoneId: response.data.payload.roomControlData[0].zoneId,
              celciusMax: response.data.payload.configs.celciusMax,
              celciusMin: response.data.payload.configs.celciusMin,
              farenheitMin: response.data.payload.configs.farenheitMin,
              farenheitMax: response.data.payload.configs.farenheitMax
            }
          }
        )
        if(CallbackRoomControlData){
          CallbackRoomControlData(true, "", thisRef);
        }
      }).catch(({response = {}}) => {

        if(response && response.data && response.data.header) CallbackRoomControlData(false, response.data.header.status.msg || response.data.header.status.message, thisRef);
        else CallbackRoomControlData(false, "Failed to get the data", thisRef);
      })
    } catch (error){
      console.log('Error in calling Room Control APIs for Inncom : ', error)
      if(window.FireBasePlugin){
        window.FirebasePlugin.logError("Error in calling Room Control APIs for Inncom " + error)
      }
      if(CallbackRoomControlData){
        CallbackRoomControlData(false, error.message, thisRef);
      }
    } 
  }
}

export const VDAsendCommand = ( action, magnitude, definedCircuit, identifier, guestDetail, callBack, zone) => {
  const roomControlPath = "/RoomControl/rest/roomControl"

  return async dispatch => {
    axios.post(
      `${CMSPath}${roomControlPath}`,
      {
        "header": {
          // "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
          "locationId": locationId || guestDetail.locationId,
          "action": action,
          "identifier": identifier,
          "zone": zone || "zone1"
        },
        "payload": {
          "magnitude": magnitude,
          "definedCircuit": definedCircuit
        }
      }
    ).then((res) => {
      console.log(`VDAsendCommand success ${action}`, res);
      if (callBack){
        callBack(true)
      }
    })
      .catch(
        (response) => {
          console.log("VDAsendCommand Api failed with the status code:", response);
          if (callBack){
            callBack(false)
          }
          if(window.FireBasePlugin){
            window.FirebasePlugin.logError("VDAsendCommand Api failed with the status code: " + response)
          }
        }
      )
  }
}
